import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import { Landing } from "./pages/Landing.tsx";
import "./styles.css";

const el = document.getElementById("root");
if (!el) throw new Error("missing #root");

// "/" → public landing; "/admin" (any sub-path) → the console + login.
// nginx serves this same SPA for every path, so we branch on the pathname here.
const isAdmin = window.location.pathname.startsWith("/admin");

createRoot(el).render(<React.StrictMode>{isAdmin ? <App /> : <Landing />}</React.StrictMode>);
